<template>
  <!-- prettier-ignore -->
  <div class="Logo">
    <svg
      viewBox="0 0 300 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M161.53 3.60097e-06C160.376 0.00504107 159.235 0.241767 158.174 0.696199C157.113 1.15063 156.153 1.81355 155.352 2.64581C154.551 3.47807 153.924 4.46278 153.509 5.54179C153.094 6.62081 152.899 7.77223 152.935 8.92806C152.924 10.0898 153.144 11.2422 153.582 12.3177C154.021 13.3933 154.669 14.3704 155.489 15.1919C156.309 16.0134 157.284 16.6629 158.357 17.1023C159.431 17.5418 160.581 17.7623 161.74 17.7511C162.905 17.7636 164.06 17.5447 165.14 17.107C166.22 16.6693 167.202 16.0216 168.031 15.2012C168.859 14.3808 169.517 13.404 169.967 12.3273C170.416 11.2505 170.649 10.0952 170.65 8.92806C170.603 6.53845 169.621 4.26304 167.915 2.59277C166.209 0.922504 163.916 -0.00872572 161.53 3.60097e-06V3.60097e-06ZM27.1488 43.1698L21.4885 41.0691C17.6101 39.5986 15.1992 38.7583 15.1992 36.4475C15.1992 34.4518 16.8763 33.5065 20.021 33.5065C24.2138 33.5065 30.608 34.8719 34.3815 35.7122L36.2683 24.5784C30.1594 23.0582 23.9027 22.2128 17.6101 22.0576C7.65199 22.0576 0 27.7295 0 37.7079C0 45.7957 4.61216 49.1568 12.6834 52.0978L17.5052 53.8835C21.8029 55.459 23.0608 55.9842 23.0608 58.1899C23.0608 60.8158 20.021 61.236 17.4004 61.236C12.7883 61.236 6.49895 59.7655 2.62055 59.1353L0.524109 70.6892C6.51654 72.024 12.6258 72.7628 18.7631 72.895C31.8658 72.895 38.4696 67.118 38.4696 57.9799C38.3648 52.2029 36.2683 46.5309 27.1488 43.1698V43.1698ZM67.4004 22.3727C60.5289 22.3917 53.6782 23.131 46.9602 24.5784L48.847 35.6072C53.2979 34.6596 57.8219 34.0973 62.369 33.9266C69.0776 33.9266 70.4402 35.7122 70.4402 40.1237V41.9094C67.8197 41.8043 65.4088 41.5942 62.5786 41.5942C51.782 41.5942 43.2914 47.6863 43.2914 58.6101C43.2914 68.7986 50.2096 72.895 57.7568 72.895C63.4172 72.895 67.7149 69.954 71.2788 67.4331L72.6415 72.2648H86.0587V41.6993C86.0587 26.6791 77.5681 22.3727 67.4004 22.3727V22.3727ZM70.3354 58.7151C68.1289 60.2947 65.4993 61.173 62.7883 61.236C60.0629 61.236 57.7568 60.0806 57.7568 57.2446C57.7568 52.413 61.74 51.7827 65.5136 51.7827C67.086 51.7827 68.5535 51.8878 70.3354 51.9928V58.7151ZM148.008 34.3468H154.088V72.2648H170.021V23.0029H148.008V34.3468ZM127.044 22.1626C118.973 22.1626 113.417 26.0489 109.434 28.8849L107.966 23.0029H95.3878V72.2648H111.216V40.3338C113.537 38.0837 116.587 36.7422 119.811 36.5525C122.851 36.5525 124.948 37.4978 124.948 42.2245V72.2648H140.776V39.0734C140.881 26.9942 135.744 22.1626 127.044 22.1626"
          :fill="startPathColor"
        />
        <path
          d="M235.639 22.3727C228.768 22.3917 221.917 23.131 215.199 24.5784L217.086 35.6072C221.537 34.6596 226.061 34.0973 230.608 33.9266C237.317 33.9266 238.679 35.7122 238.679 40.1237V41.9094C236.164 41.8043 233.648 41.5942 230.818 41.5942C220.021 41.5942 211.635 47.6863 211.635 58.6101C211.635 68.6935 218.553 72.7899 226.101 72.7899C231.761 72.7899 236.059 69.8489 239.623 67.3281L240.985 72.1597H254.298V41.6993C254.298 26.6791 245.807 22.3727 235.639 22.3727V22.3727ZM238.574 58.7151C236.399 60.2778 233.808 61.1554 231.132 61.236C228.302 61.236 226.101 60.0806 226.101 57.2446C226.101 52.413 230.084 51.7827 233.857 51.7827C235.43 51.7827 236.897 51.8878 238.679 51.9928V58.7151H238.574ZM288.574 43.1698L282.914 41.0691C279.036 39.5986 276.625 38.7583 276.625 36.4475C276.625 34.4518 278.302 33.5065 281.447 33.5065C285.639 33.5065 292.034 34.8719 295.807 35.7122L297.694 24.6835C291.585 23.1632 285.328 22.3179 279.036 22.1626C269.078 22.1626 261.426 27.8345 261.426 37.813C261.426 45.9007 266.038 49.2619 274.109 52.2029L278.931 53.9885C283.229 55.564 284.486 56.0892 284.486 58.295C284.486 60.9209 281.447 61.341 278.826 61.341C274.214 61.341 267.925 59.8705 264.151 59.2403L262.054 70.7942C268.047 72.129 274.156 72.8678 280.293 73C293.396 73 300 67.223 300 58.0849C299.79 52.2029 297.799 46.5309 288.574 43.1698V43.1698ZM195.702 55.9842V34.3468H205.451V23.0029H195.702V9.45324L179.769 11.554V59.7655C179.769 69.5338 186.478 73 193.396 73C197.667 72.9134 201.917 72.3854 206.08 71.4245V59.9755C204.083 60.4256 202.046 60.672 200 60.7108C197.17 60.7108 195.702 59.4504 195.702 55.9842"
          :fill="endPathColor"
        />
      </g>
    </svg>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

import usePartnerWidget from '@/hooks/usePartnerWidget'

// Hooks
const { partnerWidgetTheme } = usePartnerWidget()

// Data
const colors = ref({
  light: {
    startPath: '#00795D',
    endPath: '#65B32E',
  },
  darkgreen: {
    startPath: '#FFFFFF',
    endPath: '#FFFFFF',
  },
})

// Computed
const startPathColor = computed(() => {
  if (!partnerWidgetTheme.value || !colors.value[partnerWidgetTheme.value]) {
    return ''
  }
  return colors.value[partnerWidgetTheme.value].startPath
})

const endPathColor = computed(() => {
  if (!partnerWidgetTheme.value || !colors.value[partnerWidgetTheme.value]) {
    return ''
  }
  return colors.value[partnerWidgetTheme.value].endPath
})
</script>

<style scoped>
.Logo {
  width: var(--pw-logo-width);
  height: 30px;
  .wide & {
    height: 37px;
    width: 150px;
  }
}
</style>
